import { render, staticRenderFns } from "./FlowchartNode.vue?vue&type=template&id=15d526f8&scoped=true"
import script from "./FlowchartNode.vue?vue&type=script&lang=js"
export * from "./FlowchartNode.vue?vue&type=script&lang=js"
import style0 from "./FlowchartNode.vue?vue&type=style&index=0&id=15d526f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d526f8",
  null
  
)

export default component.exports